export default __webpack_public_path__ + "static/taigun-2a4821d003e50ba9712903a3e6996a3f.pdf";